module.exports = __webpack_public_path__ + "logotype.1f17dfe3465002a9688b.png";


//////////////////
// WEBPACK FOOTER
// /revet-web/src/assets/images/logotype.png
// module id = ../../../../../src/assets/images/logotype.png
// module chunks = styles